class SaveForLater extends HTMLElement {
  constructor() {
    super();

    const _this = this;

    this.cookieArray = [];
    this.cookieDuration = 30;
    this.cookieName = "saved_products";
    this.addButton = this.querySelector("button[data-add]");
    this.removeButton = this.querySelector("button[data-remove]");

    this.addButton.addEventListener('click', this.saveItem.bind(this));
    this.removeButton.addEventListener('click', this.removeItem.bind(this));

    document.addEventListener("DOMContentLoaded", function () {
      _this.removeAttribute("aria-busy");
    });

    this.initialize();
  }

  /*
  * Add the Product ID to the cookie array.
  */
  saveItem() {

    if (this.getAttribute("aria-busy")) return;
    if (this.productCheck(this.dataset.product)) return;

    let cookieArray = this.getArray();
    if(cookieArray) {
    }
    else {
      cookieArray = []
    }
    cookieArray.push(this.dataset.product);

    this.setArray(cookieArray);
    this.setState();


  }

  /*
  * Remove the Product ID from the cookie array.
  */
  removeItem() {

    if (this.getAttribute("aria-busy")) return;
    if (!this.productCheck(this.dataset.product)) return;

    let cookieArray = this.getArray();
    const position = this.getArray().indexOf(this.dataset.product);

    cookieArray.splice(position, 1);

    this.setAttribute('aria-selected', "false");
    this.setArray(cookieArray);
    this.setState();
  }

  /*
  * Check to see if the product already exists in the cookie array.
  */
  productCheck(product) {

    const cookieArray = this.getArray();
    if(cookieArray) {
      if (cookieArray.includes(product)) {
        return true;
      }

    }

    return false;
  }

  /*
   * Set the cookie from the JS array
   */
  setArray(arr) {

    // const cookieArray = this.getArray();

    window.setCookie(`${this.cookieName}`, JSON.stringify(arr), this.cookieDuration);

    console.log("Cookie Array: ", arr);
    console.log(window.getCookie(`${this.cookieName}`));
  }

  setState() {

    const cookieArray = this.getArray();

    // If the array contains this product, set the aria attributes
    if (cookieArray.includes(this.dataset.product)) {
      this.setAttribute("aria-selected", "true");
      return;
    }

    this.setAttribute('aria-selected', "false");
  }

  getArray() {
    return JSON.parse(window.getCookie(`${this.cookieName}`));
  }

  /*
  * An initializer function to set up the obect and it's properties.
  */
  initialize() {

    // Check if the cookie exists first, if not, create the cookie
    if (!window.hasCookie(`${this.cookieName}`)) window.setCookie(`${this.cookieName}`, "{0}", this.cookieDuration);;

    // Retrieve the cookie
    const cookie = window.getCookie(`${this.cookieName}`);

    // Store in a JS array
    this.cookieArray = JSON.parse(cookie);

    this.setState();
  }
}

customElements.define('save-for-later', SaveForLater);
